var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisual3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "#E3147D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.59
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.484 181.348L266.894 147.949L255.469 143.263C258.691 130.666 214.847 106.96 211.816 109.863L195.703 98.1446C180.903 90.4324 166.403 88.4558 149.977 88.4558C112.875 88.4558 73.5912 112.791 49.5116 139.453C44.5081 147.602 30.2731 150.293 33.6913 155.859C42.1904 169.701 33.135 138.875 45.703 147.949L33.6913 155.859C23.1444 155.859 30.6603 158.763 33.6913 155.859L145.814 299.942C147.197 299.978 148.584 300 149.977 300C232.699 300 288.281 234.961 296.484 181.348Z",
    fill: "url(#paint0_linear)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4923 144.588L33.4918 144.589C31.2527 147.637 31.2527 151.774 33.4918 154.823L33.492 154.823C34.5611 156.278 47.5955 173.75 68.356 190.867C89.0992 207.97 117.687 224.828 149.845 224.828C182.002 224.828 210.59 207.97 231.332 190.867C252.093 173.75 265.127 156.279 266.197 154.826L266.197 154.826C268.439 151.777 268.44 147.637 266.197 144.591C265.127 143.136 252.093 125.665 231.332 108.547C210.59 91.4441 182.002 74.5859 149.845 74.5859C117.687 74.5859 89.0992 91.4441 68.3561 108.547C47.5954 125.664 34.5611 143.135 33.4923 144.588ZM149.845 207.493C126.715 207.493 105.057 196.554 87.6237 183.724C70.7032 171.271 57.8635 157.11 51.6597 149.701C57.8549 142.287 70.6704 128.129 87.5802 115.68C105.002 102.855 126.664 91.9213 149.845 91.9213C172.973 91.9213 194.63 102.858 212.063 115.688C228.983 128.14 241.824 142.301 248.03 149.713C241.834 157.127 229.019 171.285 212.109 183.733C194.687 196.559 173.025 207.493 149.845 207.493Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.448 177.198C137.775 180.729 144.143 182.811 150.998 182.811C169.574 182.811 184.689 167.696 184.689 149.12C184.689 142.265 182.607 135.897 179.076 130.57L132.448 177.198Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.548 121.042C164.221 117.511 157.853 115.429 150.998 115.429C132.422 115.429 117.307 130.544 117.307 149.12C117.307 155.975 119.389 162.343 122.92 167.67L169.548 121.042Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.733 145.198C262.68 142.329 213.287 75 150.998 75C88.7094 75 39.3163 142.329 37.2634 145.198C35.5789 147.541 35.5789 150.699 37.2634 153.042C39.3163 155.911 88.7094 223.24 150.998 223.24C213.287 223.24 262.68 155.911 264.733 153.042C266.418 150.699 266.418 147.541 264.733 145.198ZM150.998 196.287C138.059 196.287 126.33 191.036 117.798 182.567C117.753 182.525 117.693 182.512 117.649 182.469C117.606 182.425 117.593 182.365 117.551 182.32C109.083 173.788 103.831 162.059 103.831 149.12C103.831 123.115 124.993 101.953 150.998 101.953C163.937 101.953 175.667 107.204 184.198 115.673C184.243 115.715 184.303 115.728 184.347 115.771C184.39 115.815 184.403 115.875 184.446 115.92C192.914 124.452 198.165 136.181 198.165 149.12C198.165 175.125 177.003 196.287 150.998 196.287Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 123.312,
    y1: 121.19,
    x2: 245.638,
    y2: 261.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisual3);
export default __webpack_public_path__ + "static/media/Visual 3.64dc69bf.svg";
export { ForwardRef as ReactComponent };